import Amplitude from "src/services/amplitude";
import { useEffect } from "react";
import styles from "../Banner/Banner.module.css";
import { Banner, BannerCTAs } from "../Banner/Banner";
import { IconPeopleThree } from "src/components/ui-components/Icons/IconPeopleThree";
import { Button } from "src/components/ui-components/Button/Button";
import Link from "next/link";
import AmplitudeService from "src/services/amplitude";
import {
  addToastNotification,
  addToastNotificationForApiError,
} from "shared/Toasts/toastNotificationStore";
import { useSendJoinRequest } from "./useSendJoinRequest";
import { AnchorButtonTextOnly } from "src/components/ui-components/ButtonTextOnly/AnchorButtonTextOnly";
import { useMyTeamsAndInvites } from "shared/teams/useMyTeams";

export interface SuggestTeamBannerProps {
  onDismiss: () => void;
  teamToJoin: { handle: string; name: string; id: number };
}

export function SuggestTeamBanner({
  onDismiss,
  teamToJoin,
}: SuggestTeamBannerProps) {
  const createJoinReq = useSendJoinRequest();

  const { refetch: refetchMyMemberships } = useMyTeamsAndInvites({
    fetchPolicy: "cache-only", // Only want the refetch function
  });
  useEffect(() => {
    AmplitudeService.trackEvent(
      "Suggest Team Banner Viewed",
      {},
      { linkWithTeamId: teamToJoin.id }
    );
  }, []);

  const onJoinRequestSent = async (teamId: number) => {
    createJoinReq
      .mutation({ variables: { teamId: teamId } })
      .then(() => {
        onDismiss();
        refetchMyMemberships();

        addToastNotification({
          level: "success",
          title: (
            <>
              Request sent to join{" "}
              <AnchorButtonTextOnly
                theme="tertiary"
                size="M"
                href={`/${teamToJoin.handle}`}
              >
                @{teamToJoin.name}
              </AnchorButtonTextOnly>
              .
            </>
          ),
        });
      })
      .catch((error) => {
        addToastNotificationForApiError({
          title: "Failed to submit join request",
          error,
          errorKeys: ["already_member", "not_authorised"],
        });
      });
  };

  return (
    <Banner
      dismissable
      onDismiss={() => {
        Amplitude.trackEvent(
          `Suggest Team Banner Dismissed`,
          {},
          { linkWithTeamId: teamToJoin.id }
        );
        onDismiss();
      }}
    >
      <IconPeopleThree />
      <div className={styles.copy}>
        Are you part of
        <Link href={`/${teamToJoin.handle}`} target="_blank">
          @{teamToJoin.handle}
        </Link>
        ?
      </div>
      <BannerCTAs>
        <Button
          size="S"
          theme="primary"
          disabled={createJoinReq.loading}
          onClick={() => {
            Amplitude.trackEvent(
              `Suggest Team Banner Join Team Clicked`,
              {
                team_id: teamToJoin.id,
              },
              { linkWithTeamId: teamToJoin.id }
            );
            onJoinRequestSent(teamToJoin.id);
          }}
        >
          Ask to join
        </Button>
      </BannerCTAs>
    </Banner>
  );
}
